import { useEffect } from "react";
import { useAtom } from "jotai";
import { dataConfigAtom } from "../state/atoms";
import axiosNoAuthInstance from "../../components/axiosApiNoAuth";

/**
 * Fetches data-dependent configuration from /api/data-config/ once on app load.
 * Stores result in dataConfigAtom. Components access range edges and enum options
 * via this atom with hardcoded fallbacks in constants.js for resilience.
 */
export function useDataConfig() {
  const [dataConfig, setDataConfig] = useAtom(dataConfigAtom);

  useEffect(() => {
    if (dataConfig !== null) return; // Already fetched

    async function fetchConfig() {
      try {
        const response = await axiosNoAuthInstance.get("/api/data-config/");
        setDataConfig(response.data);
      } catch (err) {
        console.warn("Failed to fetch data-config, using hardcoded fallbacks:", err);
        setDataConfig({}); // Empty object — fallbacks will be used
      }
    }

    fetchConfig();
  }, [dataConfig, setDataConfig]);

  return dataConfig;
}
